import React,{ useState, useEffect } from 'react';
import { View } from 'react-native';
import { CustomSelect, Text } from '../../../../common/component';
import {  GET_ALL_CATEGORIES } from '../../query';
import { useLazyQuery } from '@apollo/client';
import { catClient } from '../../../../common';
import { v4 as uuidv4 } from 'uuid';

interface ICategorySelectProps{
    onChange:(obj:any)=>void;
    value:any;
    backgroundColor?:string;
    width?:string;
    isLabelVisible?:boolean;
    isRequired?:boolean;
    style?:any;
};

const CategorySelect=(props:ICategorySelectProps)=>{
    
    const { onChange, value,backgroundColor,width,isLabelVisible,isRequired,style } = props;

    const categoriesValue = !!value ? (Array.isArray(value) ? value : [value]) : []

    const [categoriesData,setCategoriesData] = useState([]);
    const [getAllCategories,{data,called,error,loading}] = useLazyQuery(GET_ALL_CATEGORIES,{client:catClient});

    useEffect(()=>{
        if(!data && !called){
            getAllCategories();
        }
    },[]);

    useEffect(()=>{
        setCategoriesData(data && data.getAllCategories? data.getAllCategories : []);
    },[data]);

    let categoryDataFlattened = [];
    let level = 0;

    const createFlattenedData = (data) => {
        data.map(item => {
            const obj = { id: uuidv4(), categoryDisplayName: item.categoryDisplayName, categoryName: item.categoryName, isRoot: !item.isLeaf, level: level,disabled: false }

            if (!item.childCategories) {
                categoryDataFlattened.push(obj);
            } else {
                categoryDataFlattened.push(obj);
                level++;
                createFlattenedData(item.childCategories);
                level--;
            }
        });
    }

    createFlattenedData(categoriesData.length ? categoriesData : []);

    if(error || loading || !data) return (<View style={{width:150,justifyContent:"center",alignItems:"center"}}>
        <Text>Loading...</Text>
    </View>);
    return (
        <CustomSelect
            label={"Category"}
            labelField={'categoryDisplayName'}
            isClearVisible={true}
            valueField={'categoryName'}
            isLabelVisible={isLabelVisible ?? true}
            disabled={false}
            filterHandler={(filteredData, search) => {
                return search !== "" ? Object.values(filteredData.reduce((finalObject, item) => {
                    if (!finalObject.hasOwnProperty(item.categoryName)) {
                        finalObject[item.categoryName] = item;
                    }
                    return finalObject;
                }, {})) : filteredData;
            }}
            searchBy={'categoryDisplayName'}
            values={categoriesValue}
            level={'level'}
            keyField={'id'}
            options={categoryDataFlattened.slice()}
            isRequired={isRequired ?? true }
            boldField={'isRoot'}
            fieldName={"Category"}
            onChange={(value) => onChange(value)}
            {...(backgroundColor && { backgroundColor })}
            {...(width && { width })}    
            {...(style && { style })}
        />
    )
};

export default CategorySelect;